module.exports = __webpack_public_path__ + "static/aside.what-61de4f4c741baeca3bafd3479f0b6b7c.png";